"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidRectSize = void 0;
var isValidRectSize = function (rectSize) {
    return rectSize.height > 0 && rectSize.width > 0;
};
exports.isValidRectSize = isValidRectSize;
